import { ShoppingCart, XCircle, Package, Truck, CheckCheck, Heart, RotateCcw, Repeat, IndianRupee } from "lucide-react";

/** Shared icon + tone palette for notification kinds.
 *  Used by both NotificationBell.jsx (dropdown) and NotificationsPage.jsx (full page). */
export const KIND_ICON = {
    order_placed: ShoppingCart,
    order_cancelled_by_customer: XCircle,
    order_status_confirmed: Package,
    order_status_shipped: Truck,
    order_status_delivered: CheckCheck,
    order_status_cancelled: XCircle,
    order_status_placed: Package,
    cart_reminder: Heart,
    return_requested: RotateCcw,
    return_approved: RotateCcw,
    return_rejected: XCircle,
    return_refunded: IndianRupee,
    exchange_requested: Repeat,
    exchange_approved: Repeat,
    exchange_completed: CheckCheck,
    payment_paid: IndianRupee,
    payment_failed: XCircle,
    payment_refunded: IndianRupee,
};

export const KIND_TONE = {
    order_placed: "text-emerald-600 bg-emerald-50",
    order_cancelled_by_customer: "text-red-600 bg-red-50",
    order_status_confirmed: "text-blue-600 bg-blue-50",
    order_status_shipped: "text-amber-600 bg-amber-50",
    order_status_delivered: "text-emerald-600 bg-emerald-50",
    order_status_cancelled: "text-red-600 bg-red-50",
    order_status_placed: "text-stone-600 bg-stone-100",
    cart_reminder: "text-rosegold bg-ivory-soft",
    return_requested: "text-wine bg-rose-50",
    return_approved: "text-emerald-700 bg-emerald-50",
    return_rejected: "text-red-700 bg-red-50",
    return_refunded: "text-emerald-700 bg-emerald-50",
    exchange_requested: "text-wine bg-rose-50",
    exchange_approved: "text-emerald-700 bg-emerald-50",
    exchange_completed: "text-emerald-700 bg-emerald-50",
    payment_paid: "text-emerald-700 bg-emerald-50",
    payment_failed: "text-red-700 bg-red-50",
    payment_refunded: "text-stone-700 bg-stone-100",
};

export const fmtRelative = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60)      return "just now";
    if (diff < 3600)    return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400)   return `${Math.floor(diff / 3600)} hr ago`;
    if (diff < 604800)  return `${Math.floor(diff / 86400)} d ago`;
    return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
};
